module.exports = __webpack_public_path__ + "static/media/ellipseIcon.ef06a661.svg";